import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { skills, tabulateSkills } from '../../resources/skills';

// TanStack
import {
    createColumnHelper,
    flexRender,
    useReactTable,
    getCoreRowModel,
    getSortedRowModel,
    getFilteredRowModel
  } from '@tanstack/react-table'

import Filter from '../../resources/tableFilterFunction';

const perkData = tabulateSkills();

const columnHelper = createColumnHelper();

const perkCols = [
    columnHelper.accessor("skillName", {
        header: 'Skill'
    }),
    {
        accessorKey: 'mainAttr',
        header: '1st Attr',
        enableGlobalFilter: false
    },
    {
        accessorKey: 'expName',
        header: 'Expertise'
    },
    {
        accessorKey: 'expAttr',
        header: '2nd Attr',
        enableGlobalFilter: false
    },
    {
        accessorKey: 'perkLevel',
        header: 'Level'
    },
    {
        accessorKey: 'perkName',
        header: 'Perk',
        enableColumnFilter: false
    },
    {
        accessorKey: 'perkDesc',
        header: 'Description'
    }
]


// TO DO:
// - move global and column filters to a filter box rather than on each filter
// - Make column sorting more user friendly (maybe add icon for sorting rather than clicking whole header?)

const WikiPerkTable = ({

}) => {

    const finalData = useMemo(() => perkData, []);
    const finalCols = useMemo(() => perkCols, []);

    const [ sortState, setSorting ] = useState([])
    const [ globalFilter, setGlobalFilter ] = useState("")
    const [ columnFilters, setColumnFilters ] = useState([])

    const tableInstance = useReactTable({
        columns: finalCols,
        data: finalData,
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        state: {
            sorting: sortState,
            globalFilter: globalFilter,
            columnFilters: columnFilters
        },
        onSortingChange: setSorting,
        onGlobalFilterChange: setGlobalFilter,
        onColumnFiltersChange: setColumnFilters
      });

    return (
        <div>
            <h1>Perk Table</h1>
            <div>
                <h2>Search:</h2>
                <input className="pad-1 mary-1" type="text" value={globalFilter} onChange={e => setGlobalFilter(e.target.value)}/>
            </div>
            <table className="perkTable">
                <thead>
                {tableInstance.getHeaderGroups().map((headerEl) => {
                    return (
                    <tr key={headerEl.id}>
                        {headerEl.headers.map((columnEl) => {
                        return (
                            <th 
                                key={columnEl.id} 
                                colSpan={columnEl.colSpan}
                                onClick={columnEl.column.getToggleSortingHandler()}
                            >

                                {flexRender(
                                    columnEl.column.columnDef.header,
                                    columnEl.getContext()
                                )}
                                {
                                    columnEl.column.getCanFilter() ? (
                                        <input 
                                            type='text'
                                            value={
                                                columnEl.column.getFilterValue() || ''
                                            }
                                            onChange={(e) =>
                                                columnEl.column.setFilterValue(e.target.value)
                                            }
                                        />
                                    ) :
                                    null
                                }
                                
                                {/* Code for Sorting */}
                                { 
                                    {asc: ' △', desc: ' ▽'}
                                    [columnEl.column.getIsSorted() ?? 'null'] 
                                }
                            </th>
                        );
                        })}
                    </tr>
                    );
                })}
                </thead>
                <tbody>
                {tableInstance.getRowModel().rows.map((rowEl) => {
                    return (
                    <tr key={rowEl.id}>
                        {rowEl.getVisibleCells().map((cellEl) => {
                        return (
                            <td key={cellEl.id}>
                            {flexRender(
                                cellEl.column.columnDef.cell,
                                cellEl.getContext()
                            )}
                            </td>
                        );
                        })}
                    </tr>
                    );
                })}
                </tbody>
            </table>
        </div>
    )
}

WikiPerkTable.propTypes = {
    
};

export default (WikiPerkTable);